import { useLocation, Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation, Autoplay, A11y } from "swiper";
import { useRef } from "react";
import LazyYoutube from "./LazyYoutube";

import "swiper/swiper-bundle.css";

SwiperCore.use([Navigation, Autoplay, A11y]);

const VideosSection = ({ videoData }) => {
  const location = useLocation();
  const swiperRef = useRef(null);

  if (!videoData || !videoData.items || videoData.items.length === 0) {
    return null;
  }

  const {
    heading,
    subtitle,
    items: videos,
    more_button_text
  } = videoData;



  const isDoctorProfilePage = location.pathname
    .toLowerCase()
    .includes("doctorprofile");

  const getYoutubeId = (url) =>
  url.split("v=")[1]?.split("&")[0] || url.split("/embed/")[1];

  return (
    <section
      className={`progress-section videos-section py-5 ${isDoctorProfilePage ? "bg-white" : ""
        }`}
    >
      <div className="container position-relative">

        {/* Heading */}
        <div className="row mb-5">
          <div className="col-12 text-center">
            <h2 className="section-title text-capitalize" data-sal="slide-up"
              data-sal-duration="300"
              data-sal-delay="50"
            >
              {heading || "Healing Begins with Knowledge"}
            </h2>
            <p className="section-subtitle">
              {subtitle || "Expert Insights from Our Doctors"}
            </p>
          </div>
        </div>

        {/* Navigation */}
        <button type="button" className="slick-prev">
          <i className="fa-solid fa-chevron-left"></i>
        </button>
        <button type="button" className="slick-next">
          <i className="fa-solid fa-chevron-right"></i>
        </button>

        {/* Swiper */}
        <Swiper
          onSwiper={(swiper) => (swiperRef.current = swiper)}
          navigation={{
            prevEl: ".slick-prev",
            nextEl: ".slick-next",
          }}
          autoplay={{
            delay: 4000,
            disableOnInteraction: true,
            pauseOnMouseEnter: true,
          }}
          loop={true}
          spaceBetween={40}
          slidesPerView={3}
          breakpoints={{
            992: { slidesPerView: 3 },
            768: { slidesPerView: 2 },
            0: { slidesPerView: 1 },
          }}
          className="videos-swiper"
        >
          {videos.map((video, index) => (
            <SwiperSlide key={index}>
              <div
                className="videos-slide"
                onMouseEnter={() => swiperRef.current?.autoplay.stop()}
                onMouseLeave={() => swiperRef.current?.autoplay.start()}
              >
                <LazyYoutube videoId={getYoutubeId(video.src)} title={video.name} />

                <h3>{video.name}</h3>
                <p>{video.title}</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* More Button */}
        <div className="col-12 text-center mt-5">
          <Link to="/videoslist" className="about-btn" data-sal="slide-up"
            data-sal-duration="300"
            data-sal-delay="100">
            {more_button_text || "More Videos"}
          </Link>
        </div>

      </div>
    </section>
  );
};

export default VideosSection;
